import React, { useState } from 'react';

import { FilterAndSelectDrawer } from './FilterAndSelectDrawer';
import ReviewSelectedDrawer from './ReviewSelectedDrawer';
import LoadingFace from 'components/ui/AnimatedStates/LoadingFace';
import { getTranslatedString } from 'helpers/i18n';

const SELECT_STATES = {
  select: 'select',
  review: 'review',
  loading: 'loading',
};

const MultiselectAdvancedDrawer = ({
  handleClose,
  options,
  selectedOptions,
  handleSelect,
  filterOptions,
  handleFilter,
  fetchReviewState,
  fetchingReviewState,
  reviewStateOptions,
  verbiage,
  name,
}) => {
  const [selectState, setSelectState] = useState(SELECT_STATES.select);
  const [selected, setSelected] = useState(selectedOptions);
  const [selectedReview, setSelectedReview] = useState(selectedOptions);

  const handleContinue = async () => {
    // Set selected to the selected review
    // give selected ids a name space with formfield name
    setSelectState(SELECT_STATES.loading);
    await fetchReviewState({ property_ids: selected });
    setSelectedReview(selected.map(option => `${name}_${option}`));
    setSelectState(SELECT_STATES.review);
  };

  const handleSave = () => {
    // removing the namespace from selectedReview to get back ids as a number.
    handleSelect(selectedReview.map(selected => Number(selected.split(`${name}_`)[1])));
    handleFilter();
    handleClose();
  };

  const handleBack = () => {
    setSelected(selectedReview.map(selected => Number(selected.split(`${name}_`)[1])));
    setSelectState(SELECT_STATES.select);
  };

  if (selectState === SELECT_STATES.select) {
    return (
      <FilterAndSelectDrawer
        handleClose={handleClose}
        options={options}
        selected={selected}
        handleSelect={options => setSelected(options)}
        filterOptions={filterOptions}
        handleContinue={handleContinue}
        handleFilter={handleFilter}
        verbiage={verbiage}
        fetchingReviewState={fetchingReviewState}
      />
    );
  } else if (selectState === SELECT_STATES.review) {
    return (
      <ReviewSelectedDrawer
        handleClose={handleClose}
        handleSelect={options => setSelectedReview(options)}
        selected={selectedReview}
        handleSave={handleSave}
        verbiage={verbiage}
        handleBack={handleBack}
        name={name}
        reviewStateOptions={reviewStateOptions}
      />
    );
  } else if (selectState === SELECT_STATES.loading) {
    return (
      <LoadingFace
        headerText={getTranslatedString('landlordPortal.multiselectAdvanced.loading.header')}
        bodyText={getTranslatedString('landlordPortal.multiselectAdvanced.loading.body')}
      />
    );
  }
};

export default MultiselectAdvancedDrawer;
